import { StadiumMaterialuEnum as StadiumMaterialuEnumDto } from 'pripomienky-web-ts-axios';

enum StadiumMaterialuEnum {
  FINALNE_PREDBEZNE_STANOVISKO = 'FINALNE_PREDBEZNE_STANOVISKO',
  MPK = 'MPK',
  PRED_VYHLASENIM_V_ZBIERKE = 'PRED_VYHLASENIM_V_ZBIERKE',
  PREDPRIPRAVNA_FAZA_UKONCENA = 'PREDPRIPRAVNA_FAZA_UKONCENA',
  PRIPRAVA_MATERIALU = 'PRIPRAVA_MATERIALU',
  PRIRADENIE_GESTORA = 'PRIRADENIE_GESTORA',
  PROCES_UKONCENY = 'PROCES_UKONCENY',
  ROKOVANIE_NRSR = 'ROKOVANIE_NRSR',
  ROKOVANIE_POV = 'ROKOVANIE_POV',
  ROKOVANIE_VLADA = 'ROKOVANIE_VLADA',
  SCHVALENIE_GESTORA = 'SCHVALENIE_GESTORA',
  SCHVALOVANIE_MINISTER = 'SCHVALOVANIE_MINISTER',
  SPRACOVANIE_PREDKLADATEL = 'SPRACOVANIE_PREDKLADATEL',
  VYHLASENE_V_ZBIERKE = 'VYHLASENE_V_ZBIERKE',
  VYHODNOTENIE_MPK = 'VYHODNOTENIE_MPK',
  VYHODNOTENIE_MPK_AKTY = 'VYHODNOTENIE_MPK_AKTY',
  VYJADRENIA = 'VYJADRENIA',
  ZAPIS_STANOVISKA = 'ZAPIS_STANOVISKA',
  ZAPIS_PREDBEZNEHO_STANOVISKA = 'ZAPIS_PREDBEZNEHO_STANOVISKA',
  ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA = 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
  ADMINISTRACIA_PROCESU = 'ADMINISTRACIA_PROCESU',
  APROXIMACIA_NARIADENIA = 'APROXIMACIA_NARIADENIA',
  APROXIMACIA_SMERNICE = 'APROXIMACIA_SMERNICE',
  ARCHIVOVANY_AEU = 'ARCHIVOVANY_AEU',
  CAKAJUCI_PUB_MOD = 'CAKAJUCI_PUB_MOD',
  DOPLNENIE_POZICIE = 'DOPLNENIE_POZICIE',
  FINALIZACIA_INSTRUKCIE = 'FINALIZACIA_INSTRUKCIE',
  FINALIZACIA_NOTIFIKACNYCH_FORMULAROV = 'FINALIZACIA_NOTIFIKACNYCH_FORMULAROV',
  FINALIZACIA_POZICIE = 'FINALIZACIA_POZICIE',
  KONTROLA_REDAKC_UPRAV = 'KONTROLA_REDAKC_UPRAV',
  MZV_EZ = 'MZV_EZ',
  NOTIFIKACNY_FORMULAR = 'NOTIFIKACNY_FORMULAR',
  ODOSLANE_ROKOVANIE_NRSR = 'ODOSLANE_ROKOVANIE_NRSR',
  ODOSLANE_ROKOVANIE_VLADY = 'ODOSLANE_ROKOVANIE_VLADY',
  ODOSLANE_ZZ = 'ODOSLANE_ZZ',
  PRED_PUBLIKOVANIM = 'PRED_PUBLIKOVANIM',
  PRIEBEZNE_ZAPRACOVANIE_PRIP = 'PRIEBEZNE_ZAPRACOVANIE_PRIP',
  PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR = 'PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR',
  PRIPRAVA_MATERIALU_ADMIN = 'PRIPRAVA_MATERIALU_ADMIN',
  PRIPRAVA_MATERIALU_PI = 'PRIPRAVA_MATERIALU_PI',
  PRIPRAVA_NELEG_MATERIALU = 'PRIPRAVA_NELEG_MATERIALU',
  PRIRADENIE_GESTORA_COREPER = 'PRIRADENIE_GESTORA_COREPER',
  PRIRADENIE_GESTORA_NARIADENIE = 'PRIRADENIE_GESTORA_NARIADENIE',
  PRIRADENIE_GESTORA_RADA_EU = 'PRIRADENIE_GESTORA_RADA_EU',
  PRIRADENIE_GESTORA_SMERNICA = 'PRIRADENIE_GESTORA_SMERNICA',
  PUBLIKACIA_RO = 'PUBLIKACIA_RO',
  ROKOVANIE_LRV = 'ROKOVANIE_LRV',
  ROKOVANIE_NRSR_NELEG_MAT = 'ROKOVANIE_NRSR_NELEG_MAT',
  ROKOVANIE_PRAC_KOMISII = 'ROKOVANIE_PRAC_KOMISII',
  ROKOVANIE_PREDKLADATEL = 'ROKOVANIE_PREDKLADATEL',
  ROKOVANIE_PREDKLADATEL_NELEG_MAT = 'ROKOVANIE_PREDKLADATEL_NELEG_MAT',
  ROKOVANIE_VLADA_NELEG_MAT = 'ROKOVANIE_VLADA_NELEG_MAT',
  SEFREDAKTOR_PRIDELOVANIE = 'SEFREDAKTOR_PRIDELOVANIE',
  SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD = 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD',
  SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT = 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT',
  SCHVALENE_NA_VLADE = 'SCHVALENE_NA_VLADE',
  SCHVALOVANIE_PREZIDENT = 'SCHVALOVANIE_PREZIDENT',
  SPRACOVANIE_REDAKTOR = 'SPRACOVANIE_REDAKTOR',
  SPRACOVANIE_REDAKTOR_NELEG_MAT = 'SPRACOVANIE_REDAKTOR_NELEG_MAT',
  SPRACOVANIE_SEFREDAKTOR = 'SPRACOVANIE_SEFREDAKTOR',
  SPRACOVANIE_SEFREDAKTOR_NELEG_MAT = 'SPRACOVANIE_SEFREDAKTOR_NELEG_MAT',
  VYHODNOTENIE_MPK_NELEG_MAT = 'VYHODNOTENIE_MPK_NELEG_MAT',
  VYHODNOTENIE_ROKOVANIA_NRSR = 'VYHODNOTENIE_ROKOVANIA_NRSR',
  VYHODNOTENIE_VYSLEDKU_ROKOVANIA = 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA',
  VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT = 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT',
  VYTVORENIE_CIASTKOVEJ_INSTRUKCIE = 'VYTVORENIE_CIASTKOVEJ_INSTRUKCIE',
  VYTVORENIE_POZICIE = 'VYTVORENIE_POZICIE',
  ZAEVIDOVANIE_MATERIALU = 'ZAEVIDOVANIE_MATERIALU',
  ZAEVIDOVANIE_OPATRENIA = 'ZAEVIDOVANIE_OPATRENIA',
}

export default StadiumMaterialuEnum;

export const generatedToStadiumMaterialuMap = new Map([
  [StadiumMaterialuEnumDto.FinalnePredbezneStanovisko, StadiumMaterialuEnum.FINALNE_PREDBEZNE_STANOVISKO],
  [StadiumMaterialuEnumDto.Mpk, StadiumMaterialuEnum.MPK],
  [StadiumMaterialuEnumDto.PredVyhlasenimVZbierke, StadiumMaterialuEnum.PRED_VYHLASENIM_V_ZBIERKE],
  [StadiumMaterialuEnumDto.PredpripravnaFazaUkoncena, StadiumMaterialuEnum.PREDPRIPRAVNA_FAZA_UKONCENA],
  [StadiumMaterialuEnumDto.PripravaMaterialu, StadiumMaterialuEnum.PRIPRAVA_MATERIALU],
  [StadiumMaterialuEnumDto.PriradenieGestora, StadiumMaterialuEnum.PRIRADENIE_GESTORA],
  [StadiumMaterialuEnumDto.ProcesUkonceny, StadiumMaterialuEnum.PROCES_UKONCENY],
  [StadiumMaterialuEnumDto.RokovanieNrsr, StadiumMaterialuEnum.ROKOVANIE_NRSR],
  [StadiumMaterialuEnumDto.RokovaniePov, StadiumMaterialuEnum.ROKOVANIE_POV],
  [StadiumMaterialuEnumDto.RokovanieVlada, StadiumMaterialuEnum.ROKOVANIE_VLADA],
  [StadiumMaterialuEnumDto.SchvalenieGestora, StadiumMaterialuEnum.SCHVALENIE_GESTORA],
  [StadiumMaterialuEnumDto.SchvalovanieMinister, StadiumMaterialuEnum.SCHVALOVANIE_MINISTER],
  [StadiumMaterialuEnumDto.SpracovaniePredkladatel, StadiumMaterialuEnum.SPRACOVANIE_PREDKLADATEL],
  [StadiumMaterialuEnumDto.VyhlaseneVZbierke, StadiumMaterialuEnum.VYHLASENE_V_ZBIERKE],
  [StadiumMaterialuEnumDto.VyhodnotenieMpk, StadiumMaterialuEnum.VYHODNOTENIE_MPK],
  [StadiumMaterialuEnumDto.VyhodnotenieMpkAkty, StadiumMaterialuEnum.VYHODNOTENIE_MPK_AKTY],
  [StadiumMaterialuEnumDto.Vyjadrenia, StadiumMaterialuEnum.VYJADRENIA],
  [StadiumMaterialuEnumDto.ZapisStanoviska, StadiumMaterialuEnum.ZAPIS_STANOVISKA],
  [StadiumMaterialuEnumDto.ZapisPredbeznehoStanoviska,
    StadiumMaterialuEnum.ZAPIS_PREDBEZNEHO_STANOVISKA],
  [StadiumMaterialuEnumDto.ZapisDoplnenehoPredbeznehoStanoviska,
    StadiumMaterialuEnum.ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA],
  [StadiumMaterialuEnumDto.AdministraciaProcesu, StadiumMaterialuEnum.ADMINISTRACIA_PROCESU],
  [StadiumMaterialuEnumDto.AproximaciaNariadenia, StadiumMaterialuEnum.APROXIMACIA_NARIADENIA],
  [StadiumMaterialuEnumDto.AproximaciaSmernice, StadiumMaterialuEnum.APROXIMACIA_SMERNICE],
  [StadiumMaterialuEnumDto.ArchivovanyAeu, StadiumMaterialuEnum.ARCHIVOVANY_AEU],
  [StadiumMaterialuEnumDto.CakajuciPubMod, StadiumMaterialuEnum.CAKAJUCI_PUB_MOD],
  [StadiumMaterialuEnumDto.DoplneniePozicie, StadiumMaterialuEnum.DOPLNENIE_POZICIE],
  [StadiumMaterialuEnumDto.FinalizaciaInstrukcie, StadiumMaterialuEnum.FINALIZACIA_INSTRUKCIE],
  [StadiumMaterialuEnumDto.FinalizaciaNotifikacnychFormularov,
    StadiumMaterialuEnum.FINALIZACIA_NOTIFIKACNYCH_FORMULAROV],
  [StadiumMaterialuEnumDto.FinalizaciaPozicie, StadiumMaterialuEnum.FINALIZACIA_POZICIE],
  [StadiumMaterialuEnumDto.KontrolaRedakcUprav, StadiumMaterialuEnum.KONTROLA_REDAKC_UPRAV],
  [StadiumMaterialuEnumDto.MzvEz, StadiumMaterialuEnum.MZV_EZ],
  [StadiumMaterialuEnumDto.NotifikacnyFormular, StadiumMaterialuEnum.NOTIFIKACNY_FORMULAR],
  [StadiumMaterialuEnumDto.OdoslaneRokovanieNrsr, StadiumMaterialuEnum.ODOSLANE_ROKOVANIE_NRSR],
  [StadiumMaterialuEnumDto.OdoslaneRokovanieVlady, StadiumMaterialuEnum.ODOSLANE_ROKOVANIE_VLADY],
  [StadiumMaterialuEnumDto.OdoslaneZz, StadiumMaterialuEnum.ODOSLANE_ZZ],
  [StadiumMaterialuEnumDto.PredPublikovanim, StadiumMaterialuEnum.PRED_PUBLIKOVANIM],
  [StadiumMaterialuEnumDto.PriebezneZapracovaniePrip, StadiumMaterialuEnum.PRIEBEZNE_ZAPRACOVANIE_PRIP],
  [StadiumMaterialuEnumDto.PripomienkovaniePozmenNavrhovNrsr,
    StadiumMaterialuEnum.PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR],
  [StadiumMaterialuEnumDto.PripravaMaterialuAdmin, StadiumMaterialuEnum.PRIPRAVA_MATERIALU_ADMIN],
  [StadiumMaterialuEnumDto.PripravaMaterialuPi, StadiumMaterialuEnum.PRIPRAVA_MATERIALU_PI],
  [StadiumMaterialuEnumDto.PripravaNelegMaterialu, StadiumMaterialuEnum.PRIPRAVA_NELEG_MATERIALU],
  [StadiumMaterialuEnumDto.PriradenieGestoraCoreper, StadiumMaterialuEnum.PRIRADENIE_GESTORA_COREPER],
  [StadiumMaterialuEnumDto.PriradenieGestoraNariadenie, StadiumMaterialuEnum.PRIRADENIE_GESTORA_NARIADENIE],
  [StadiumMaterialuEnumDto.PriradenieGestoraRadaEu, StadiumMaterialuEnum.PRIRADENIE_GESTORA_RADA_EU],
  [StadiumMaterialuEnumDto.PriradenieGestoraSmernica, StadiumMaterialuEnum.PRIRADENIE_GESTORA_SMERNICA],
  [StadiumMaterialuEnumDto.PublikaciaRo, StadiumMaterialuEnum.PUBLIKACIA_RO],
  [StadiumMaterialuEnumDto.RokovanieLrv, StadiumMaterialuEnum.ROKOVANIE_LRV],
  [StadiumMaterialuEnumDto.RokovanieNrsrNelegMat, StadiumMaterialuEnum.ROKOVANIE_NRSR_NELEG_MAT],
  [StadiumMaterialuEnumDto.RokovaniePracKomisii, StadiumMaterialuEnum.ROKOVANIE_PRAC_KOMISII],
  [StadiumMaterialuEnumDto.RokovaniePredkladatel, StadiumMaterialuEnum.ROKOVANIE_PREDKLADATEL],
  [StadiumMaterialuEnumDto.RokovaniePredkladatelNelegMat, StadiumMaterialuEnum.ROKOVANIE_PREDKLADATEL_NELEG_MAT],
  [StadiumMaterialuEnumDto.RokovanieVladaNelegMat, StadiumMaterialuEnum.ROKOVANIE_VLADA_NELEG_MAT],
  [StadiumMaterialuEnumDto.SefredaktorPridelovanie, StadiumMaterialuEnum.SEFREDAKTOR_PRIDELOVANIE],
  [StadiumMaterialuEnumDto.SefredaktorSchvaleniePredPubmod, StadiumMaterialuEnum.SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD],
  [StadiumMaterialuEnumDto.SefredaktorSchvaleniePredPubmodNelegMat,
    StadiumMaterialuEnum.SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT],
  [StadiumMaterialuEnumDto.SchvaleneNaVlade, StadiumMaterialuEnum.SCHVALENE_NA_VLADE],
  [StadiumMaterialuEnumDto.SchvalovaniePrezident, StadiumMaterialuEnum.SCHVALOVANIE_PREZIDENT],
  [StadiumMaterialuEnumDto.SpracovanieRedaktor, StadiumMaterialuEnum.SPRACOVANIE_REDAKTOR],
  [StadiumMaterialuEnumDto.SpracovanieRedaktorNelegMat, StadiumMaterialuEnum.SPRACOVANIE_REDAKTOR_NELEG_MAT],
  [StadiumMaterialuEnumDto.SpracovanieSefredaktor, StadiumMaterialuEnum.SPRACOVANIE_SEFREDAKTOR],
  [StadiumMaterialuEnumDto.SpracovanieSefredaktorNelegMat, StadiumMaterialuEnum.SPRACOVANIE_SEFREDAKTOR_NELEG_MAT],
  [StadiumMaterialuEnumDto.VyhodnotenieMpkNelegMat, StadiumMaterialuEnum.VYHODNOTENIE_MPK_NELEG_MAT],
  [StadiumMaterialuEnumDto.VyhodnotenieRokovaniaNrsr, StadiumMaterialuEnum.VYHODNOTENIE_ROKOVANIA_NRSR],
  [StadiumMaterialuEnumDto.VyhodnotenieVysledkuRokovania, StadiumMaterialuEnum.VYHODNOTENIE_VYSLEDKU_ROKOVANIA],
  [StadiumMaterialuEnumDto.VyhodnotenieVysledkuRokovaniaNelegMat,
    StadiumMaterialuEnum.VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT],
  [StadiumMaterialuEnumDto.VytvorenieCiastkovejInstrukcie, StadiumMaterialuEnum.VYTVORENIE_CIASTKOVEJ_INSTRUKCIE],
  [StadiumMaterialuEnumDto.VytvoreniePozicie, StadiumMaterialuEnum.VYTVORENIE_POZICIE],
  [StadiumMaterialuEnumDto.ZaevidovanieMaterialu, StadiumMaterialuEnum.ZAEVIDOVANIE_MATERIALU],
  [StadiumMaterialuEnumDto.ZaevidovanieOpatrenia, StadiumMaterialuEnum.ZAEVIDOVANIE_OPATRENIA],
]);

export function generatedToStadiumMaterialuEnum(generated: StadiumMaterialuEnumDto): StadiumMaterialuEnum {
  return generatedToStadiumMaterialuMap.get(generated);
}
